module.exports = __webpack_public_path__ + "img/Bjoern.39d3775d.png";